export function applyFocusedClass(contentEl, hash) {
  const target = contentEl?.querySelector(
    `span[id="${hash.replace(/#/, '')}"]`,
  );
  target && target.classList.add('focused');
}
